module.exports = __webpack_public_path__ + "static/img-about@2x-6911209103d574b1625ea9f391c01154.png";